// ABOUTME: Aviso da migração do cadastro/edição de restaurantes para o admin novo.
// ABOUTME: Banner informativo na listagem; modal bloqueante nas telas de criar e editar.
import React from "react";
import { Alert, Button, Modal, ModalHeader, ModalBody } from "reactstrap";

const ADMIN_URL = "https://admin.takeat.app";
const WHATSAPP_NUMBER = "5527998839703";

const adminLink = (restaurantId) =>
  restaurantId
    ? `${ADMIN_URL}/restaurants/edit/${restaurantId}`
    : `${ADMIN_URL}/restaurants/create`;

const whatsappLink = (screen, restaurantId, restaurantName) => {
  const where = restaurantId
    ? `editar o restaurante ${restaurantName || ""} (id ${restaurantId})`
    : "criar um restaurante";
  const text =
    `Olá! Estou migrando do painel antigo para o admin novo (${ADMIN_URL}) ` +
    `e preciso de ajuda para ${where}. Tela: ${screen}.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};

export function MigrationBanner() {
  return (
    <Alert color="warning" style={{ marginTop: 8 }}>
      <strong>O cadastro e a edição de restaurantes migraram.</strong> Use o{" "}
      <a
        href={ADMIN_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="alert-link"
      >
        admin novo ({ADMIN_URL.replace("https://", "")})
      </a>
      . Esta tela segue disponível para consulta.
    </Alert>
  );
}

// Sem toggle de propósito: criar e editar por aqui foi desativado.
export function MigrationModal({ screen, restaurantId, restaurantName }) {
  return (
    <Modal isOpen backdrop="static" keyboard={false}>
      <ModalHeader>
        Esta tela migrou para o admin novo
      </ModalHeader>
      <ModalBody>
        <p>
          A criação e a edição de restaurantes agora são feitas no{" "}
          <strong>admin novo</strong> ({ADMIN_URL.replace("https://", "")}).
          Por aqui não é mais possível {restaurantId ? "editar" : "criar"} —
          esta tela será desativada em breve.
        </p>
        <p>
          Se algo estiver faltando lá, ou se encontrar qualquer problema no
          cadastro ou na edição, fale direto com o time de desenvolvimento.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          <Button
            color="success"
            tag="a"
            href={adminLink(restaurantId)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Abrir no admin novo
          </Button>
          <Button
            color="link"
            tag="a"
            href={whatsappLink(screen, restaurantId, restaurantName)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Falar com o desenvolvimento (WhatsApp)
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}
